module.exports = __webpack_public_path__ + "img/img-21.6af57e15.png";